export const NotificationEnum = {
  General: 0,
  Message: 1,
  Subscription: 2,
  Score: 3,
  Workout: 4,
  RemovedFromGroup: 5,
};
